export default __webpack_public_path__ + "static/media/CancelOrderOn.8c86fb44.svg";